module.exports = __webpack_public_path__ + "img/shelton-computer-logo.4969699f.jpg";